export default "__VITE_ASSET__e17jePcV__"